<div *ngIf="entity" editorType="medium">
  <form *ngIf="form" [formGroup]="form">
    <div class="column">
      <dx-text-box [readOnly]="false" formField required formControlName="code"></dx-text-box>
      <dx-text-area [readOnly]="false" formField required formControlName="name"></dx-text-area>
      <dx-text-area [readOnly]="false" formField required formControlName="version"></dx-text-area>
    </div>
  </form>
  <div class="controls">
    <dx-tab-panel class="tabs-content">
      <dxi-item [title]="'entity.product' | translate | ucfirst" dataType="string">
        <div class="flex-1 p-5 border">
        <div class="flex flex-col flex-1">
          <dx-data-grid
                #grid
                id="grid-container-costs"
                keyExpr="id"
                class="flex-1"
                [dataSource]="bomProducts"
                [showBorders]="false"
                [showColumnLines]="false"
                [showRowLines]="false"
                [rowAlternationEnabled]="true"
                [columnAutoWidth]="true"
                [wordWrapEnabled]="true"
                height="0"

                style="max-width: 800px;"
              >
                <dxo-sorting mode="multiple"></dxo-sorting>
                <dxo-editing
                  mode="row"
                  [allowDeleting]="false"
                  [allowUpdating]="false"
                  [allowAdding]="false"
                  [useIcons]="false"
                ></dxo-editing>

                <dxi-column class="gs-gridColumn" dataField="product.code" [caption]="'entity.code' | translate | ucfirst" dataType="string"></dxi-column>
                <dxi-column class="gs-gridColumn" dataField="product.name" [caption]="'entity.product' | translate | ucfirst" dataType="string"></dxi-column>
                <dxi-column class="gs-gridColumn" dataField="productTypeId" [caption]="'entity.type' | translate | ucfirst" dataType="string">
                  <dxo-lookup
                    [dataSource]="productTypes"
                    displayExpr="displayName"
                    valueExpr="id"
                  ></dxo-lookup>
                </dxi-column>
                <dxi-column class="gs-gridColumn" dataField="quantity" [caption]="'entity.quantity' | translate | ucfirst" dataType="string"></dxi-column>
              </dx-data-grid>
          <div class="flex-initial">
            <!-- aquí hi pot haver un footer del datagrid -->
          </div>
        </div>
        </div>
      </dxi-item>
      <dxi-item [title]="'entity.materials' | translate | ucfirst" dataType="string">
        <div class="flex-1 p-5 border">
        <div class="flex flex-col flex-1">
          <dx-data-grid
                #grid
                id="grid-container-costs"
                keyExpr="id"
                class="flex-1"
                [dataSource]="bomMaterials"
                [showBorders]="false"
                [showColumnLines]="false"
                [showRowLines]="false"
                [rowAlternationEnabled]="true"
                [columnAutoWidth]="true"
                [wordWrapEnabled]="true"
                height="0"

                style="max-width: 800px;"
              >
                <dxo-sorting mode="multiple"></dxo-sorting>
                <dxo-editing
                  mode="row"
                  [allowDeleting]="false"
                  [allowUpdating]="false"
                  [allowAdding]="false"
                  [useIcons]="false"
                ></dxo-editing>

                <dxi-column class="gs-gridColumn" dataField="product.code" [caption]="'entity.code' | translate | ucfirst" dataType="string"></dxi-column>
                <dxi-column class="gs-gridColumn" dataField="product.name" [caption]="'entity.material' | translate | ucfirst" dataType="string"></dxi-column>
                <dxi-column class="gs-gridColumn" dataField="quantity" [caption]="'entity.quantity' | translate | ucfirst" dataType="string"></dxi-column>

              </dx-data-grid>
          <div class="flex-initial">
            <!-- aquí hi pot haver un footer del datagrid -->
          </div>
        </div>
        </div>
      </dxi-item>
    </dx-tab-panel>
  </div>
</div>
